 

export default async ()=>{
    const code = window.location.search.replace("?","")
    if(code==="private"&&window.location.host.includes("localhost")){
        return true
    }
}